import { Grid, Typography } from "@material-ui/core";
import EmptyStateSVG from "./svg";

export const EmptyState = ({ message }) => {
  return (
    <Grid
      container
      direction="column"
      alignContent="center"
      style={{ padding: "24px 0", gap: 16 }}
    >
      <Grid item>
        <center>
          <EmptyStateSVG />
        </center>
      </Grid>
      <Grid item>
        <Typography
          align="center"
          color="primary"
          variant="h4"
          style={{ fontWeight: "bold" }}
        >
          {message}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          align="center"
          variant="subtitle2"
          style={{
            color: "#858585",
            maxWidth: 400,
            fontWeight: 500,
          }}
        >
          Por favor, verifique os filtros selecionados ou tente fazer uma nova
          busca com diferentes valores.
        </Typography>
      </Grid>
    </Grid>
  );
};
